import { getAuthCode } from "./getAuthCode";
export const updateICP = async(ICP) => {
    try {
      const authCode = await getAuthCode()
      const response = await fetch(process.env.REACT_APP_BACKEND_URL + "/updateICP", {
        method: "POST",
        credentials: 'include',
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({auth_code:authCode,ICP:ICP}),
      });
      const result = await response.json();
    } catch (error) {
      console.log(error);
    }
}